/**
 * Limits of the vehicle logbook (FAFD-26), mirrored from the backend so forms reject what the API
 * would: `VehicleLogbookEntryEntity.MaxOdometerKm`, `DestinationMaxLength`, `PurposeMaxLength`.
 */
export const MAX_ODOMETER_KM = 9_999_999;
export const DESTINATION_MAX_LENGTH = 200;
export const PURPOSE_MAX_LENGTH = 500;
